import { useContext, useEffect, useState } from 'react';
import airtel from '../../../../assets/Airtel.svg';
import { AuthContext } from '../../../../context/authContext';
import { getDataPlans } from '../../service/dataPlans';
import DataPayment from './DataPayment';
import useBuyData from './useBuyData';

const AirtelDataPayment = () => {
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [dataPlans, setDataPlans] = useState([]);

  useEffect(() => {
    getDataPlans(userId, setDataPlans);
  }, [userId]);

  const {
    handleDataSubscription,
    setMobileNumber,
    mobileNumber,
    selectedOption,
    setSelectedOption,
    loading,
    success,
  } = useBuyData();

  const removeWords = (word) => `${word.split(' ').slice(1, 4).join('')})`;

  const filterDataPlansithLabel = () => {
    return dataPlans
      .filter((plan) => plan.provider === 'AIRTEL')
      .map((m) => ({ ...m, label: removeWords(m.name) }));
  };

  return (
    <DataPayment
      logo={airtel}
      sucess={success}
      dataPlans={filterDataPlansithLabel()}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setMobileNumber={setMobileNumber}
      mobileNumber={mobileNumber}
      handleDataSubscription={() => handleDataSubscription(4)}
      loading={loading}
    />
  );
};

export default AirtelDataPayment;
